import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Emit, Watch, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let AccordionComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.visible = false;
  }
  toggle() {
    if (this.controlled) {
      return this.visible;
    }
    this.visible = !this.visible;
    return this.visible;
  }
  changeVisibility() {
    if (this.controlled) {
      this.visible = this.initiallyVisible;
      return;
    }
    if (this.initiallyVisible && !this.visible || !this.initiallyVisible && this.visible) {
      this.toggle();
    }
  }
  get elevationClass() {
    if (this.elevation <= 0 || this.elevation > 5) {
      return "";
    }
    return `accordion--elevation-${this.elevation}`;
  }
};
__decorateClass([
  Prop({ type: Boolean, default: false })
], AccordionComponent.prototype, "topNavVariant", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], AccordionComponent.prototype, "initiallyVisible", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], AccordionComponent.prototype, "noAnimation", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], AccordionComponent.prototype, "wide", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], AccordionComponent.prototype, "noOverflow", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], AccordionComponent.prototype, "controlled", 2);
__decorateClass([
  Prop({ type: Number, default: 0 })
], AccordionComponent.prototype, "elevation", 2);
__decorateClass([
  Emit("toggle")
], AccordionComponent.prototype, "toggle", 1);
__decorateClass([
  Watch("initiallyVisible", { immediate: true })
], AccordionComponent.prototype, "changeVisibility", 1);
AccordionComponent = __decorateClass([
  Component({
    name: "ui-accordion",
    inheritAttrs: false
  })
], AccordionComponent);

export default AccordionComponent;
